import { render } from "./VerifierComp.vue?vue&type=template&id=be273f16&scoped=true"
import script from "./VerifierComp.vue?vue&type=script&lang=js"
export * from "./VerifierComp.vue?vue&type=script&lang=js"

import "./VerifierComp.vue?vue&type=style&index=0&id=be273f16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be273f16"]])

export default __exports__